<template>
  <div v-if="first && spacialViewLink" class="BookingRoomDetailsCarouselItem">
    <ai-image v-bind="props.image" />

    <a
      :href="spacialViewLink"
      target="_blank"
      rel="noopener noreferrer"
      class="BookingRoomDetailsCarouselItem-overlay">
      <div class="BookingRoomDetailsCarouselItem-overlay-body">
        <ai-icon
          name="360-view"
          :size="40"
          class="BookingRoomDetailsCarouselItem-overlay-icon" />

        <ai-typo
          as="span"
          variant="button-bold"
          color="white"
          class="BookingRoomDetailsCarouselItem-overlay-label">
          {{ $t('booking.rooms.details.see360View') }}
        </ai-typo>
      </div>
    </a>
  </div>

  <ai-image v-else v-bind="props.image" />
</template>

<script setup lang="ts">
import type { Maybe } from '@graphql-tools/utils';

import type { Accommodation } from '~~/domains/graphql';

type Props = {
  image: {
    src?: string | Maybe<string>;
    srcSet?: string;
    alt?: string;
    decorative?: boolean;
    fetchPriority?: 'high';
    loading?: 'lazy' | 'eager';
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  room?: Accommodation;
  first?: boolean;
  last?: boolean;
};

const props = defineProps<Props>();

const spacialViewLink = computed(
  () => props.room?.spacialViewLink as string | undefined,
);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';

.BookingRoomDetailsCarouselItem {
  position: relative;
}

.BookingRoomDetailsCarouselItem-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  color: colors.$white;
}

.BookingRoomDetailsCarouselItem-overlay-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.BookingRoomDetailsCarouselItem-overlay-icon {
  margin-bottom: constants.$inner-02;
}

.BookingRoomDetailsCarouselItem-overlay-label {
  text-transform: uppercase;
}
</style>
